import Meta from '@/components/common/Meta'

import InternationalShippingAndStorageServicesPage from '@/v2/components/pages/landing-pages/international-shipping-and-storage-services-page'
import { LANDING_PAGES_META_CONTENTS } from '@/v2/constants/pages/landing-pages/meta/landing-pages-meta-content'
import {
  metaImages,
  ogImages
} from '@/v2/constants/pages/landing-pages/international-shipping-and-storage-services-page'

interface InternationalShippingAndStorageServicesPageProps {}

const Page: React.FC<InternationalShippingAndStorageServicesPageProps> = () => {
  return (
    <>
      <Meta
        title={
          LANDING_PAGES_META_CONTENTS.international_shipping_and_storage_services.title ??
          LANDING_PAGES_META_CONTENTS.default?.title ??
          ''
        }
        keywords={
          LANDING_PAGES_META_CONTENTS.international_shipping_and_storage_services?.keywords ??
          LANDING_PAGES_META_CONTENTS.default?.keywords ??
          ''
        }
        description={
          LANDING_PAGES_META_CONTENTS.international_shipping_and_storage_services?.description ??
          LANDING_PAGES_META_CONTENTS.default?.description ??
          ''
        }
        openGraph={{
          images: ogImages
        }}
        searchImages={metaImages}
      />

      <InternationalShippingAndStorageServicesPage />
    </>
  )
}

export default Page
